import React from "react";

export default function AcademicSchedule({
  className,
  cls1,
  cls2,
  cls3,
  cls4,
}) {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="10 10 100 100"
      className={className}
    >
      <defs></defs>
      <path
        className={cls1}
        d="M34.47,33.77c.22-2.8-.42-5.65,2.11-7.61a7.11,7.11,0,0,1,5.47-1.05,6.65,6.65,0,0,1,3.44,1.39,6.44,6.44,0,0,1,1.7,3.16,19.87,19.87,0,0,1,0,4.08H60.05c.22-2.81-.32-5.77,2.35-7.74a7.38,7.38,0,0,1,5.27-.93c5.53.36,5.47,4.47,5.35,8.67h4.22a4.22,4.22,0,0,1,4.45,4h0V80.91a4.29,4.29,0,0,1-3.91,4.6h0a4.33,4.33,0,0,1-.72,0H30.58a4.29,4.29,0,0,1-4.75-3.77,3.1,3.1,0,0,1,0-.86V38.57a4.22,4.22,0,0,1,3.75-4.64h0a4,4,0,0,1,.85,0ZM77.19,46.71H30.25V81.24H77.19ZM43.05,35.37V31c0-1.46-.93-1.67-2.12-1.64s-2.35-.15-2.24,1.64V38.6c0,2.54,0,2.72,2.84,2.66,1.16,0,1.56-.49,1.52-1.61S43.05,36.82,43.05,35.37Zm21.45-.3v4.69c0,1.05.45,1.5,1.48,1.48h1.39c1,0,1.44-.4,1.44-1.39v-9.1c0-.91-.39-1.36-1.29-1.39H65.8c-1,0-1.36.45-1.33,1.46C64.53,32.32,64.5,33.74,64.5,35.07Z"
      />
      <rect
        className={cls1}
        x="35.59"
        y="51.85"
        width="9.11"
        height="9.11"
        rx="1.63"
      />
      <rect
        className={cls1}
        x="49.18"
        y="51.85"
        width="9.11"
        height="9.11"
        rx="1.63"
      />
      <rect
        className={cls1}
        x="62.76"
        y="51.85"
        width="9.11"
        height="9.11"
        rx="1.63"
      />
      <rect
        className={cls1}
        x="35.59"
        y="66.99"
        width="9.11"
        height="9.11"
        rx="1.63"
      />
      <rect
        className={cls1}
        x="49.18"
        y="66.99"
        width="9.11"
        height="9.11"
        rx="1.63"
      />
      <rect
        className={cls1}
        x="62.76"
        y="66.99"
        width="9.11"
        height="9.11"
        rx="1.63"
      />
      <path
        className={cls2}
        d="M77.13,61A17.06,17.06,0,1,1,60.09,78h0A17.07,17.07,0,0,1,77.13,61Z"
      />
      <path
        className={cls3}
        d="M77.13,91A12.94,12.94,0,1,0,64.18,78,12.93,12.93,0,0,0,77.13,91Z"
      />
      <path className={cls4} d="M77.14,69.3v10a.65.65,0,0,0,.65.65h5.89" />
    </svg>
  );
}

{
  /* <style>.cls-1,.cls-2{fill:#e35f14;}.cls-2{stroke:#fff;stroke-miterlimit:10;stroke-width:2.88px;}.cls-3{fill:#fff;}.cls-4{fill:none;stroke:#e35f14;stroke-linecap:round;stroke-linejoin:bevel;stroke-width:2.66px;}</style> */
}
